export default __webpack_public_path__ + "static/media/herotwo.ac9aaf24.png";